import axios from "axios";
import { FeaturesEnabledRequest, FeaturesEnabledResponse } from "../../Types/FeaturesEnabled";

export const getFeaturesEnabled = async (request: FeaturesEnabledRequest) => {
  try {
    const queryParams = new URLSearchParams(request as any).toString();
    const path = import.meta.env.VITE_BACKEND_API + "/api/client/featuresEnabled?" + queryParams;
    const res = await axios.get<FeaturesEnabledResponse>(path);
    return res.data;
  } catch (error) {
    console.error(error);
    return {
      lastUpdated: "",
      clients: [],
      features: [],
    } as FeaturesEnabledResponse;
  }
};
